export default "__VITE_ASSET__ELYVANAN__"